module.exports = __webpack_public_path__ + "static/media/courses.9764ffd8.png";